/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Eine Schriftrolle: eine Schriftart und ihre drei Groessenstufen. Die Stufen sind CSS-Groessen ("14px", "1.2rem"); leer heisst "erbt".
 * @export
 * @interface DatabaseSchriftrolle
 */
export interface DatabaseSchriftrolle {
    /**
     * Schriftart dieser Rolle. Leer = die Schrift des Farbschemas.
     * @type {string}
     * @memberof DatabaseSchriftrolle
     */
    familie?: string;
    /**
     * Groessenstufe "klein" dieser Rolle.
     * @type {string}
     * @memberof DatabaseSchriftrolle
     */
    klein?: string;
    /**
     * Groessenstufe "mittel" -- die Vorgabe fuer alle Elemente der Rolle.
     * @type {string}
     * @memberof DatabaseSchriftrolle
     */
    mittel?: string;
    /**
     * Groessenstufe "gross" dieser Rolle.
     * @type {string}
     * @memberof DatabaseSchriftrolle
     */
    gross?: string;
}

/**
 * Check if a given object implements the DatabaseSchriftrolle interface.
 */
export function instanceOfDatabaseSchriftrolle(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseSchriftrolleFromJSON(json: any): DatabaseSchriftrolle {
    return DatabaseSchriftrolleFromJSONTyped(json, false);
}

export function DatabaseSchriftrolleFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseSchriftrolle {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'familie': !exists(json, 'familie') ? undefined : json['familie'],
        'klein': !exists(json, 'klein') ? undefined : json['klein'],
        'mittel': !exists(json, 'mittel') ? undefined : json['mittel'],
        'gross': !exists(json, 'gross') ? undefined : json['gross'],
    };
}

export function DatabaseSchriftrolleToJSON(value?: DatabaseSchriftrolle | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'familie': value.familie,
        'klein': value.klein,
        'mittel': value.mittel,
        'gross': value.gross,
    };
}

